<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      isLogin: localStorage.getItem("yx_isLogin") || false,
      userInfo: JSON.parse(localStorage.getItem("yx_userInfo")) || null,

      websock: null,
      reconnectData: null,
      lockReconnect: false, //避免重复连接，因为onerror之后会立即触发 onclose
      timeout: 60000, //60s一次心跳检测
      timeoutObj: null,
      serverTimeoutObj: null,

      notify: null,
    };
  },
  created() {
    if (this.isLogin) {
      this.notify = new Notify({
        effect: "scroll",
        interval: 500,
        disableFavicon: true,
      });

      // 判断浏览器弹框通知是否被阻止
      console.log("浏览器弹框通知是否被阻止：" + this.notify.isPermission());

      this.initWebSocket();
    }
  },
  methods: {
    // 初始化weosocket
    initWebSocket() {
      console.log("策略选股（外） 启动中");
      // let wsurl = `ws://172.20.10.13:9099/h5ws?userNo=${this.userInfo.userNo}&channel=sellsAll`;
      let wsurl = `wss://yxcloudsocket.yxcps.cn/h5ws?userNo=${this.userInfo.userNo}&channel=ai_strategy_notice_desktop`;
      this.websock = new WebSocket(wsurl);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose; //连接关闭
    },
    // 连接成功
    websocketonopen() {
      console.log("策略选股（外） 连接成功");
      this.heatBeat();
    },
    // 连接失败
    websocketonerror() {
      console.log("策略选股（外） 连接失败");
      this.reconnect();
    },
    // 各种问题导致的 连接关闭
    websocketclose() {
      console.log("策略选股（外） 断开连接");
      this.reconnect();
    },
    // 数据接收
    websocketonmessage(data) {
      this.heatBeat(); //收到消息会刷新心跳检测，如果一直收到消息，就推迟心跳发送

      if (data.data == "Hello world!") {
        return;
      }
      let msgData = JSON.parse(data.data);

      if (this.notify.isPermission()) {
        if (
          this.Cookies.get(`strategy_messageId_${msgData.strategyId}`) ==
          msgData.messageId
        ) {
          return;
        }

        this.Cookies.set(
          `strategy_messageId_${msgData.strategyId}`,
          msgData.messageId,
          {
            expires: 1,
            path: "/",
            domain: ".yxcps.com",
            sameSite: "Strict",
          }
        );

        console.log(msgData);

        this.receive(msgData); // 浏览器 通知
      }
    },
    // 数据发送
    websocketsend(data) {
      this.websock.send(JSON.stringify(data));
    },
    // socket重连
    reconnect() {
      if (this.lockReconnect) {
        //这里很关键，因为连接失败之后之后会相继触发 连接关闭，不然会连接上两个 WebSocket
        return;
      }
      this.lockReconnect = true;
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.initWebSocket();
        this.lockReconnect = false;
      }, 40000);
    },
    // 心跳检测
    heatBeat() {
      this.timeoutObj && clearTimeout(this.timeoutObj);
      this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
      this.timeoutObj = setTimeout(() => {
        this.websocketsend({ type: "心跳检测" }); //根据后台要求发送
        this.serverTimeoutObj = setTimeout(() => {
          this.websock.close(); //如果  40秒之后我们没有收到 后台返回的心跳检测数据 断开socket，断开后会启动重连机制
        }, 40000);
      }, this.timeout);
    },

    // 浏览器 通知
    receive(data) {
      // console.log(data);
      let that = this;

      that.notify.setTitle("您有一条新消息，请注意查看");

      let domParser = new DOMParser();
      let doc = domParser.parseFromString(data.content, "text/html");
      let body = doc.body.textContent || "";

      let redirectUrl = `https://www.yxcps.com/strategy?code=${data.strategyCode}&navIndex=5&searchVal=${data.title}`;
      console.log("跳转链接：" + redirectUrl);

      that.notify.notify({
        title: data.title,
        body: body,
        openurl: redirectUrl,
        onclick: function () {
          console.log("notify click");

          // that.COMMON.zhuGeMaidian("click_wb_inter", {
          //   goods_name: data.title,
          //   goods_id: data.sellsId,
          //   source: "notify",
          // }); // 诸葛 埋点
        },
      });

      that.notify.player();

      setTimeout(function () {
        that.notify.setTitle();
      }, 10000);

      // console.log("websocket 接收消息" + data.data);
    },
  },
  destroyed() {
    this.lockReconnect = true;
    this.websock.close(); //离开路由之后断开websocket连接
    clearTimeout(this.reconnectData); //离开清除 timeout
    clearTimeout(this.timeoutObj); //离开清除 timeout
    clearTimeout(this.serverTimeoutObj); //离开清除 timeout
  },
};
</script>